import { UPDATE_INFO_USER } from 'redux/types/Type'

export const updateInfoUserAction = (payload) => ({
  type: UPDATE_INFO_USER,
  payload,
})
